import { MgLocalStorageKeys } from '@enums';
import { setMgLocalStorage } from '@utils';
import { lettersPageActionTypes } from './actionTypes/lettersPage';
import { makeSubmissions, setCheckedSubmissions } from './submissionActions';
import { SubmissionQueryInterface } from '@types';
import _cloneDeep from 'lodash/cloneDeep';

export const setIsOpenSaveAsModal = (isOpen: boolean) => {
  return {
    type: lettersPageActionTypes.SET_IS_OPEN_SAVE_AS_MODAL,
    payload: isOpen,
  };
};

export const setIsOpenChangeTypeModal = (isOpen: boolean) => {
  return {
    type: lettersPageActionTypes.SET_IS_OPEN_CHANGE_TYPE_MODAL,
    payload: isOpen,
  };
};

export const setIsOpenReassignGroupModal = (isOpen: boolean) => {
  return {
    type: lettersPageActionTypes.SET_IS_OPEN_REASSIGN_GROUP_MODAL,
    payload: isOpen,
  };
};

export const setIsOpenDownloadModal = (isOpen: boolean) => {
  return {
    type: lettersPageActionTypes.SET_IS_OPEN_DOWNLOAD_MODAL,
    payload: isOpen,
  };
};

export const setIsOpenDeleteModal = (isOpen: boolean) => {
  return {
    type: lettersPageActionTypes.SET_IS_OPEN_DELETE_MODAL,
    payload: isOpen,
  };
};

export const setIsOpenMultipleDeleteModal = (isOpen: boolean) => {
  return {
    type: lettersPageActionTypes.SET_IS_OPEN_MULTIPLE_DELETE_MODAL,
    payload: isOpen,
  };
};

export const setFilters = (value: Partial<SubmissionQueryInterface>) => {
  return {
    type: lettersPageActionTypes.SET_FILTERS,
    payload: value,
  };
};
export const setPartialFilters = (
  value: Partial<SubmissionQueryInterface>,
  fromCache = false,
  redirect = true,
  redirectId?: string
) => {
  return (dispatch, getState) => {
    const store = getState();
    const filters = store.lettersPage.filters;

    const updatedQuery = { ...filters, ...value };

    dispatch(setFilters(_cloneDeep(updatedQuery)));
    setMgLocalStorage(MgLocalStorageKeys.LETTERS_FILTERS, updatedQuery);
    dispatch(setCheckedSubmissions([]));
    dispatch(makeSubmissions(updatedQuery, fromCache, redirect, redirectId));
  };
};
